export const customFilterValue = (value: string) => {
  switch (value) {
    case 'INVITED':
      return 'Onboarding not Started';

    case 'STRIPE_ACCOUNT_MADE':
      return 'Onboarding in Progress';

    case 'STRIPE_LINK_COMPLETED':
      return 'Onboarded';

    default:
      return value;
  }
};
